import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';

@Component({
  selector: 'app-accredited-investors',
  templateUrl: './accredited-investors.component.html',
  styleUrls: ['./accredited-investors.component.scss']
})
export class AccreditedInvestorsComponent implements OnInit {
  constructor(public modalRef: BsModalRef) {}

  ngOnInit() {}
}
